/*
 * AZP-7077 — the mobile search screen (snippets/search-overlay.liquid).
 *
 * Below 990px the design turns search into a full screen of its own: logo, close
 * button, the field, then the suggestions. The header keeps its inline box because
 * that is what the rest of the header layout is built on — tapping it hands over to
 * this overlay, which carries the real field.
 *
 * Above 990px nothing here runs: the header box opens its own dropdown.
 */
(function () {
  "use strict";

  var BREAKPOINT = 990;

  function isMobile() {
    return window.matchMedia("(max-width: " + (BREAKPOINT - 1) + "px)").matches;
  }

  class SearchOverlay extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[name="q"]');
      this.predictive = this.querySelector("predictive-search");
      this.isOpen = false;

      this.addEventListener("click", this.onClick.bind(this));
      document.addEventListener("keydown", this.onKeydown.bind(this));

      if (this.input) {
        this.input.addEventListener("input", this.syncState.bind(this));
        // <predictive-search> empties the field on clear without firing `input`.
        this.addEventListener("click", this.syncStateSoon.bind(this));
      }

      this.attachTriggers();
      this.syncState();
    }

    /* The header box is the trigger. It stays a real input so that nothing about the
     * header layout changes, and so the desktop dropdown keeps working untouched.
     * AZP-7310: the home page hero field is a trigger too, so tapping it on mobile
     * opens this same screen instead of the hero's own inline dropdown. */
    attachTriggers() {
      var self = this;

      var triggers = ".header .head-slot-mid input[name=q], .bs-hero-search input[name=q]";

      document.querySelectorAll(triggers).forEach(function (trigger) {
        var hand_over = function (event) {
          if (!isMobile() || self.isOpen) return;

          event.preventDefault();
          trigger.blur();
          self.trigger = trigger;
          self.open(trigger.value);
        };

        trigger.addEventListener("focus", hand_over);
        trigger.addEventListener("click", hand_over);
      });
    }

    open(term) {
      this.hidden = false;
      this.isOpen = true;
      document.documentElement.classList.add("bs-search-overlay-open");

      if (this.input) {
        if (term) {
          this.input.value = term;
          // Let <predictive-search> answer for the term the shopper already typed.
          this.input.dispatchEvent(new Event("input", { bubbles: true }));
        }

        this.input.focus();
      }

      this.syncState();
    }

    close() {
      if (!this.isOpen) return;

      // Hand the term back, so the header box shows what the shopper typed here.
      if (this.trigger && this.input) {
        this.trigger.value = this.input.value;
      }

      this.hidden = true;
      this.isOpen = false;
      document.documentElement.classList.remove("bs-search-overlay-open");
    }

    onClick(event) {
      if (event.target.closest("[data-search-overlay-close]")) {
        event.preventDefault();
        this.close();
        return;
      }

      // The Model Finder modal lives at the end of <body>, below this overlay.
      if (event.target.closest("[data-model-locator-open]")) {
        this.close();
      }
    }

    syncStateSoon() {
      setTimeout(this.syncState.bind(this));
    }

    onKeydown(event) {
      if (event.key === "Escape" && this.isOpen) {
        this.close();
      }
    }

    /* "empty" shows the Locate Model Number prompt, "typing" gives the panel the room. */
    syncState() {
      var hasTerm = !!(this.input && this.input.value.trim().length);

      this.dataset.state = hasTerm ? "typing" : "empty";
    }
  }

  customElements.define("search-overlay", SearchOverlay);
})();
